<template>
  <div
    ref="menu_block"
    class="pa-6 pr-8 pt-2  main__light_green">
    <sForm
      ref="dateCellForm"
      :model="{comment, date, for_all}">
      <v-card
        ref="card"
        class="date-card pa-0 main__light_green"
        elevation="0">
        <v-card-subtitle class="pb-2 px-0 font-weight-medium text-start h5-headline black--text">
          {{ $t('Catalog.DateReceiveSubtitle') }}
        </v-card-subtitle>
        <DateRadioMenu
          class="main__light_green"
          :comment.sync="comment"
          :date.sync="date"
          :item="item"
          :menu.sync="menu"
          show_comment
          @fieldsChange="$emit('fieldsChange', item)"/>
        <v-card-actions class="flex-direction-column align-start px-0 pt-0">
          <span class="h5-headline">{{ $t(`Tenders.ApplyAllItems`) }}</span>
          <sFormItem
            prop="for_all"
            :show-message="false">
            <sRadioGroup
              v-model="for_all"
              class="mt-4"
              data-qa="radio-group-for-all"
              row>
              <sRadio
                data-qa="radio-group-for-all-no"
                :label="false">
                {{ $t('Tenders.No') }}
              </sRadio>
              <sRadio
                class="ml-13"
                data-qa="radio-group-for-all-yes"
                :label="true">
                {{ $t('Tenders.Yes') }}
              </sRadio>
            </sRadioGroup>
          </sFormItem>
        </v-card-actions>
        <v-card-actions>
          <sButton
            data-qa="btn-apply"
            @click="apply">
            {{ $t(`Common.Apply`) }}
          </sButton>
        </v-card-actions>
      </v-card>
    </sForm>
  </div>
</template>
<script>
import DateRadioMenu from 'components/common/blocks/DateRadioMenu.vue'

import moment from 'moment'
import { filterSortMixin, modalMixin } from 'mixins'

export default {
  name: 'dateCell',
  mixins: [ filterSortMixin, modalMixin ],
  data() {
    return {
      menu: false,
      date: '',
      comment: '',
      for_all: false,
    }
  },
  created() {
    this.comment = this.item.urgentReason || ''
    this.date = (this.item.declaredPriority.id  ? this.item.declaredPriority.id : (this.item.declaredSupplyDate || this.item.approvedSupplyDate)
      && moment(this.item.declaredSupplyDate || this.item.approvedSupplyDate).format('YYYY-MM-DD') ) ||  '0'
  },
  computed: {
    ref_menu() {
      return this.$refs.cell_menu
    },
  },
  props: {
    item: Object,
    items: Array
  },
  methods: {
    apply() {
      this.$refs.dateCellForm.validate((valid) => {
        if (!valid) {
          this.$notice.info({
            title: this.$t('Common.PleaseNote'),
            message: this.$t('Validate.checkRequiredFelds'),
          })
          return
        }
        let apply = ( item ) => {
          if (this.date.length > 1) {
            item.declaredSupplyDate = moment(this.date).format('YYYY-MM-DDTHH:mm:ss')
            item.declaredPriority = {id: ''}
            item.urgentReason = ''
          } else {
            item.declaredPriority = {id: this.date}
            item.declaredSupplyDate = null
            item.urgentReason = this.comment
          }
        }
        if (this.items && this.for_all) {
          this.items.forEach( item => apply(item) )
        } else {
          apply(this.item)
        }
        this.$emit('fieldsChange', this.item)
        this.menu = false
      })
    }
  },
  watch: {
    date() {
      setTimeout(() => {
        if ( !this.$refs.menu_block) {
          return
        }
        const window_relative_height = document.documentElement.getBoundingClientRect().height,
          menu_params = this.$refs.menu_block.getBoundingClientRect(),
          window_height_w_menu = menu_params.height + menu_params.top,
          height_diff  = window_relative_height - window_height_w_menu
        if (height_diff < 0) {
          this.$refs.menu_block.parentNode.style.top =  parseInt(this.$refs.menu_block.parentNode.style.top) + height_diff - 30 + 'px'
        }
      }, 100)
    }
  },
  components: {
    DateRadioMenu
  }
}
</script>
<style lang="scss" scoped>
.date.folder {
  height: 100%;
  width: 100%;
}
</style>
